<template>
	<div>
		<div class="profile">
			<img v-if="false" class="profile-image" :src="profile_picture" @click="load_profile" />
			<div class="profile-name">
				{{ $api.user.name }}<br/>
				<span :title="$api.user.company_name">{{ $api.user.company_name }}</span>
			</div>
		</div>

		<div class="menu-items">
			<router-link class="menu-item" to="/" data-v-step-home="0">
				<i class="fa fa-fw fa-home"></i> INÍCIO
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('Customer')" class="menu-item" to="/customer" data-v-step-customer="0">
				<i class="fa fa-fw fa-building"></i> CLIENTES
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('DistributionCenter') && $api.user.company_routing" class="menu-item" to="/distribution_center" data-v-step-distribution-center="0">
				<i class="fa fa-fw fa-pallet"></i> CENTROS DISTRIBUIÇÃO
			</router-link>
			
			<router-link v-if="$permission.hasAreaPermission('Driver')" class="menu-item" to="/driver" data-v-step-driver="0">
				<i class="fa fa-fw fa-address-card"></i> MOTORISTAS
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('Vehicle') && $api.user.company_routing" class="menu-item" to="/vehicle" data-v-step-vehicle="0">
				<i class="fa fa-fw fa-truck"></i> VEÍCULOS
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('Delivery')" class="menu-item" to="/delivery" data-v-step-delivery="0">
				<i class="fa fa-fw fa-boxes"></i> ENTREGAS
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('DeliveryRouting') && $api.user.company_routing" class="menu-item" to="/routing" data-v-step-routing-list="0">
				<i class="fa fa-fw fa-route"></i> ROTEIRIZAÇÕES
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('Tracking')" class="menu-item" to="/tracking" data-v-step-tracking="0">
				<i class="fa fa-fw fa-map-marked-alt"></i> RASTREIO
			</router-link>
			
			<router-link v-if="$permission.hasAreaPermission('Report')" class="menu-item" to="/report" data-v-step-report="0">
				<i class="fa fa-fw fa-file-invoice"></i> RELATÓRIO
			</router-link>

			<router-link v-if="$permission.hasAreaPermission('Config')" class="menu-item" to="/config" data-v-step-config="0">
				<i class="fa fa-fw fa-cog"></i> CONFIGURAÇÕES
			</router-link>

			<a class="menu-item" @click="logout" data-v-step-customer="11">
				<i class="fa fa-fw fa-sign-out-alt"></i> SAIR
			</a>

			<!--a v-if="account_payment == 'no_invoice'" class="menu-item menu-footer no-invoice" @click="() => { return false; }">
				<i class="fa fa-fw fa-chalkboard-teacher"></i> PERíODO DE DEGUSTAÇÃO
			</a>
			<router-link v-if="account_payment == 'overdue'" class="menu-item menu-footer overdue" to="/config">
				<i class="fa fa-fw fa-exclamation-triangle"></i> FATURA EM ABERTO
			</router-link-->
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

const default_profile = require('@/assets/user.png');

export default {
	name: "Menu",

	data: function() {
		return {
			profile_url: false,
			account_payment: false
		}
	},

	computed: {
		profile_picture: function() {
			if (!this.profile_url) return default_profile;
			return this.profile_url;
		}
	},

	created: function() {
		/*if (this.has_permission('Config')) {
			this.load_account_payment();
		}*/
	},

	methods: {
		load_profile: async function() {
			this.profile_url = false;
			let res = await Api.blob("auth/my-profile");
			this.profile_url = res;
		},

		load_account_payment: async function() {
			let res = await Api.get("invoice/state");
			
			if (res.error) return;
			this.account_payment = res.data;
		},

		logout: function() {
			Api.logout();
		},
	}
}
</script>

<style scoped>
.header {
	float: left;
	width: 100%;
	padding: 15px 55px 0 55px;
}

.header-image {
	width: 100%;
}



.profile {
	float: left;
	width: 100%;
	padding: 15px;
	background: #595959;
}


.profile-image {
	float: left;
	width: 50px;
	height: 50px;
	border-radius: 100%;
	background: #fff;
}



.profile-name {
	position: relative;
    float: left;
    width: calc(100% - 60px);
    color: #fff;
    text-align: left;
    /*padding: 6px 0 0px 15px;*/
}
.profile-name > span {
	display: block;
	color: #fff;
	font-size: 12px;
	font-weight: bold;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding-top: 5px;
}





.menu-items {
	position: relative;
	float: left;
	width: 100%;
	padding-top: 1px;
	margin-top: 0px;
	height: calc(100vh - 80px);
}

.menu-item {
	position: relative;
	float: left;
	width: 100%;
	height: 50px;
	line-height: 52px;
	background: #d9d9d9;
	border: none;
	text-align: left;
	padding: 0 15px 0 50px;
	color: #000;
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 1px;
	text-decoration: none;
}

.menu-item > i {
	position: absolute;
	top: 16px;
	left: 15px;
	font-size: 18px;
}

.router-link-exact-active {
	background: #a6a6a6;
}





.menu-footer {
	position: absolute;
	left: 0;
	bottom: 0;
}


.no-invoice {
	color: #fff;
	background: #bda814;
}

.overdue {
	color: #fff;
	background: red;
}

</style>